import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone! I’m <span className="purple">Ahmed Elshobaky</span> from{" "}
            <span className="purple">Damietta, Egypt</span>.<br />
            I’m a Front‑End Developer with over 3 years of experience building
            high-performance web apps using{" "}
            <span className="purple">React.js</span>,{" "}
            <span className="purple">Next.js</span>, and{" "}
            <span className="purple">Tailwind CSS</span>.<br />
            I can turn Figma designs into fully responsive, pixel‑perfect
            websites, and I excel at:
          </p>

          <ul style={{ marginTop: "1rem", paddingLeft: "1.2rem" ,textAlign: "justify"}}>
            <li>Boosting load speed to PageSpeed scores ≥95.</li>
            <li>Leveraging SSR/SSG in Next.js for better SEO.</li>
            <li>Building interactive UIs with animations and React Hooks.</li>
            <li>Integrating RESTful APIs and managing state with Redux or Context API.</li>
            <li>Ensuring accessibility (ARIA, semantic HTML).</li>
            <li>Collaborating in Git/GitHub and Agile/Scrum workflows.</li>
          </ul>

          <p style={{ textAlign: "justify", marginTop: "1rem" }}>
            I stay updated on new tech (Web3, Jamstack), use tools like Vite and
            Webpack, and write unit tests with <span className="purple">Jest</span>{" "}
            for reliable code.
          </p>

          <h1 className="purple" style={{textAlign: "justify", marginTop: "3rem"}}>
            SERVICES
            </h1> 
          <ul style={{ marginBottom: "1rem", paddingLeft: "1.2rem" ,textAlign: "justify" }}>
            <li>Designing and developing modern UIs with HTML, CSS, JavaScript, and React.js.</li>
            <li>Building fully responsive web apps for all devices.</li>
            <li>Implementing interactive features (animations, real-time updates).</li>
            <li>Integrating third‑party APIs and services (Stripe, Google Maps, etc.).</li>
            <li>Performance optimization, code‑splitting, and lazy‑loading.</li>
            <li>Writing clean, maintainable code with SEO best practices.</li>
          </ul>

          <p style={{ color: "rgb(155 126 172)", marginTop: "2rem" }}>
            "I strive to build projects that make a real impact!"
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
